export default "__VITE_ASSET__fb61c063__"